import { render, staticRenderFns } from "./InitiateRegistrationFormModal.vue?vue&type=template&id=06456220&scoped=true&"
import script from "./InitiateRegistrationFormModal.vue?vue&type=script&lang=js&"
export * from "./InitiateRegistrationFormModal.vue?vue&type=script&lang=js&"
import style0 from "./InitiateRegistrationFormModal.vue?vue&type=style&index=0&id=06456220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06456220",
  null
  
)

export default component.exports